import { computed, ref } from 'vue'
import { enums } from '@app/state/enums/enums'
import { createData } from './partials/data'
// import { createForm, applyFormSubmissionApiCallback } from './partials/form'
import { createForm } from './partials/form'
import { createDataWatches, createFormFieldWatches } from './partials/helpers/watches/watches'

/**
 * Create sections for the membership state
 */
const data = createData()
const form = createForm()

/**
 * Create watches for the data APIs details
 */
createDataWatches(data, form)

/**
 * Create watches for the form fields
 */
createFormFieldWatches(data, form)

/**
 * Apply callbacks for the state sections which require different parts of the state
 */
// applyFormSubmissionApiCallback(form, data.membership_type)

const state = {
    /**
     * Objects for the different sections of the state
     */
    data        : data,
    enums       : enums,
    form        : form,

    view_only : ref(false)
}

export default state

/**
 * So we can access these parts of the state independently inside the different steps
 */
export {
    data,
    form,
    enums
}
